import { Wrapper } from '@cinch-nx/shared-ui'
import { Head, renderWithResolver } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import cx from 'classnames'

import styles from './feature-new-car-offers.module.css'

import {
  BRANDS_CONTENT,
  INTRO_CONTENT,
  OUR_OFFERS_CONTENT,
  SEO_CONTENT,
} from './data'

export function FeatureNewCarOffers() {
  const { title: introTitle, body: introBody } = INTRO_CONTENT
  const { title: offersTitle, body: offersBody } = OUR_OFFERS_CONTENT

  const introBodyContent = renderWithResolver(introBody)
  const offersBodyContent = renderWithResolver(offersBody)

  const { trackEvent } = useAnalytics()

  const onClickHandler = (brandName: string) => {
    trackEvent({
      eventName: `Customer Reviews -  click search all cars button`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'link',
          label: 'Choose Manufacturer',
          action: brandName,
        },
      },
    })
  }

  return (
    <>
      <Head
        {...SEO_CONTENT}
        fallbackTitle="New car offers"
        fallbackDescription="Discover new car offers at our sister site, Marshall Motor Group. Learn more about the latest new car promotions and visit Marshall to buy your next car."
      />
      <article className={styles.root}>
        <Wrapper className={{ container: styles.newCarOffersWrapper }} isSlim>
          <h1 className={styles.heading}>{introTitle}</h1>
          <div>{introBodyContent}</div>
        </Wrapper>
        <Wrapper
          className={{
            container: cx(styles.newCarOffersWrapperCentered, styles.fullWidth),
          }}
        >
          <h2 className={styles.heading}>{offersTitle}</h2>
          <div>{offersBodyContent}</div>
        </Wrapper>
        <Wrapper
          className={{
            container: cx(
              styles.newCarOffersWrapperSmallMargin,
              styles.sectionSpacer,
            ),
          }}
          isSlim
        >
          <div className={styles.brandNames}>
            {BRANDS_CONTENT.map((brand) => {
              const { name, url } = brand
              const key = name.toLowerCase().replace(' ', '-')
              return (
                <div
                  key={key}
                  className={styles.brandContainer}
                  onClick={() => onClickHandler(name)}
                >
                  <a href={url} target="_blank" rel="noreferrer">
                    {name}
                  </a>
                </div>
              )
            })}
          </div>
        </Wrapper>
      </article>
    </>
  )
}
